export enum RouteEnum {
  Chat = "/",
  Translation = "/translation",
  WritingAssistance = "/writing-assistance",
  MediaGeneration = "/media-generation",
  Build = "/build",
  Demos = "/demos",
}
